import { createStore } from 'zustand/vanilla';
import { persist } from 'zustand/middleware';
import { createTenantPersistConfig, PERSIST_STORE_KEYS } from '../persist';

type TabScopedStoreState = {
  entries: Record<string, Record<string, unknown>>;
  updateEntry: (
    scopeKey: string,
    value: Partial<Record<string, unknown>>,
  ) => void;
  clearEntry: (scopeKey: string) => void;
  clearAllForTab: (tabId: string) => void;
};

export const tabScopedStore = createStore<TabScopedStoreState>()(
  persist(
    (set) => ({
      entries: {},

      updateEntry: (scopeKey, value) =>
        set((state) => ({
          entries: {
            ...state.entries,
            [scopeKey]: { ...(state.entries[scopeKey] ?? {}), ...value },
          },
        })),

      clearEntry: (scopeKey) =>
        set((state) => {
          const { [scopeKey]: _removed, ...remaining } = state.entries;
          return { entries: remaining };
        }),

      clearAllForTab: (tabId) =>
        set((state) => ({
          entries: Object.fromEntries(
            Object.entries(state.entries).filter(
              ([key]) => !key.includes(`tabId_${tabId}/`),
            ),
          ),
        })),
    }),
    {
      ...createTenantPersistConfig({
        storeKey: PERSIST_STORE_KEYS.tabScoped,
        storage: 'superjson',
      }),
      partialize: (state) => ({ entries: state.entries }),
    },
  ),
);

export function clearAllTabScopedEntries(tabId: string) {
  tabScopedStore.getState().clearAllForTab(tabId);
}

export function pruneOrphanTabScopedEntries(
  validTabIds: ReadonlySet<string>,
): void {
  const tabIdSegment = /tabId_([^/]+)\//;
  tabScopedStore.setState((state) => ({
    entries: Object.fromEntries(
      Object.entries(state.entries).filter(([key]) => {
        const m = key.match(tabIdSegment);
        if (!m) return true;
        return validTabIds.has(m[1]);
      }),
    ),
  }));
}
